// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"9919dce3","453":"0dd3d456"}[chunkId] + ".chunk.js";
};